import { Injectable, OnDestroy, ChangeDetectorRef, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { BehaviorSubject, Subject, Subscription, Observable, finalize, takeUntil } from 'rxjs';
import { GlobalService } from './global.service';

// Add constants
const CALENDAR_CONSTANTS = {
  TOAST_DURATION: 3000,
  TOAST_POSITION: 'bottom' as const,
  DEFAULT_BREAKPOINTS: [0, 0.5, 0.75, 1] as number[],
  DEFAULT_INITIAL_BREAKPOINT: 0.75,
  REVIEW_TRIGGER: "1"
};
interface GoogleResponse {
  message?: string;
}
@Injectable({
  providedIn: 'root'
})
export class CalendarService implements OnDestroy {

  private subscriptions = new Subscription();
  private destroy$ = new Subject<void>();
  public calendarUpdated:  BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public pendingOAuthCode: BehaviorSubject<string | null> = new BehaviorSubject<string | null>(null);

  constructor(
    private globalService: GlobalService,
    private router: Router,
    private modalController: ModalController,
  ) {
    console.log("🚀 Initializing CalendarService");
  }



  
  async saveGoogleOAuthCode(code: string, type: string): Promise<boolean> {
    return new Promise(async (resolve, reject) => {
      try {
        const dataString = { 
          'code': code,
          'type': type,
        };

        console.log('💾 Saving Google OAuth code with data:', dataString);

        const sub = (await this.globalService.request('post', true, 'ionic_postGoogleOauth', dataString))
          .pipe(
            takeUntil(this.destroy$),
            finalize(() => {
              console.log('✅ Completed saveGoogleOAuthCode request');
            })
          )
          .subscribe({
            next: (res: GoogleResponse) => {
              console.log('📨 Server response:', res);
              
              if (!res) {
                resolve(false);
                return;
              }

              if (res.message) {
                this.globalService.presentToast(res.message, CALENDAR_CONSTANTS.TOAST_DURATION, CALENDAR_CONSTANTS.TOAST_POSITION);
              }

              resolve(true);
            },
            error: (error) => {
              console.error('❌ Error saving OAuth code:', error);
              this.globalService.presentToast('Failed to save Google OAuth code', CALENDAR_CONSTANTS.TOAST_DURATION, CALENDAR_CONSTANTS.TOAST_POSITION);
              reject(error);
            }
          });
        
        this.subscriptions.add(sub);
      } catch (error) {
        console.error('❌ Error in saveGoogleOAuthCode:', error);
        reject(error);
      }
    });
  }
  
  
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.subscriptions.unsubscribe();
  }



}
